import React from "react";
import { useDevVerticalEmbedItems } from "./../../ricos-context/index.js";
import { useRequestService } from "./../../_shared/request-service-provider/request-service-provider.js";
const VERTICAL_PATHS = {
  product: "products",
  event: "events",
  booking: "bookings"
};
const buildServerlessApiUrl = (type, locale, options) => {
  let url = `https://www.wixapis.com/ricos/v1/vertical-oembed/query-${VERTICAL_PATHS[type]}?language=${locale}`;
  if (options?.limit) {
    url += `&limit=${options.limit}`;
  }
  if (options?.filter) {
    url += `&filter=${options.filter}`;
  }
  return url;
};
const processServerlessApiResponse = (response) => {
  if (Array.isArray(response)) {
    return response;
  } else if (response.status === "success" && response.data) {
    return response.data;
  } else if (response.errMsg) {
    console.error("Vertical embed API error:", response.errMsg);
    return [];
  }
  return [];
};
const useVerticalEmbedRequestService = () => {
  const { makeRequest } = useRequestService();
  const devVerticalEmbedService = useDevVerticalEmbedItems();
  const fetchVerticalEmbedItems = async (type, query = "", locale = "en") => {
    if (devVerticalEmbedService) {
      return devVerticalEmbedService(type, query);
    }
    const options = {
      limit: 50
    };
    if (type === "product" || type === "event") {
      if (query) {
        options.filter = query;
      }
    }
    const url = buildServerlessApiUrl(type, locale, options);
    try {
      const response = await makeRequest(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("API response error:", errorText);
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
      }
      const responseText = await response.text();
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        console.error("Failed to parse JSON response:", parseError);
        console.error("Response was:", responseText);
        throw new Error(`Invalid JSON response from ${url}: ${responseText.substring(0, 100)}...`);
      }
      const items = processServerlessApiResponse(data);
      if (type === "booking" && query) {
        return items.filter((item) => item.name.toLowerCase().includes(query.toLowerCase()));
      }
      return items;
    } catch (error) {
      console.error("Failed to fetch vertical embed items:", error);
      throw error;
    }
  };
  const fetchVerticalEmbedItem = async (type, embedId, locale = "en") => {
    try {
      const items = await fetchVerticalEmbedItems(type, "", locale);
      return items.find((item) => item.id === embedId) || null;
    } catch (error) {
      console.error("Failed to fetch vertical embed item:", error);
      return null;
    }
  };
  return React.useMemo(() => {
    return {
      fetchVerticalEmbedItems,
      fetchVerticalEmbedItem
    };
  }, [makeRequest]);
};
export {
  useVerticalEmbedRequestService
};
//# sourceMappingURL=fetchVerticalEmbedData.js.map
